import { useCallback, useEffect, useState } from "react";

const KEY = "mm_fx_all";
const FALLBACK = ["AUD", "BDT", "USD", "EUR", "GBP", "INR", "PKR", "NZD", "CAD", "SGD", "MYR", "AED", "SAR", "JPY", "CNY"];
const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { return null; } };

// Live rates for every world currency, based on USD so any-to-any works
export function useFxRates() {
  const [st, setSt] = useState(() => load() || { rates: null, t: 0 });

  const refresh = useCallback(async () => {
    try {
      const ctl = new AbortController();
      const to = setTimeout(() => ctl.abort(), 7000);
      const r = await fetch("https://open.er-api.com/v6/latest/USD", { cache: "no-store", signal: ctl.signal });
      clearTimeout(to);
      const j = await r.json();
      if (j?.rates?.USD) { const n = { rates: j.rates, t: Date.now() }; setSt(n); localStorage.setItem(KEY, JSON.stringify(n)); }
    } catch (e) { /* keep last saved rates */ }
  }, []);

  useEffect(() => { if (!st.rates || Date.now() - st.t > 30 * 60000) refresh(); }, [refresh, st.rates, st.t]);

  const codes = st.rates ? Object.keys(st.rates).sort() : FALLBACK;
  const rate = (from, to) => (st.rates?.[from] && st.rates?.[to] ? st.rates[to] / st.rates[from] : 0);
  return { codes, rate, at: st.t, refresh };
}
